<template>

  <div ref="container" class="field-container" :class="{ focusing: focus }" :style="{ width: column.width + 'px' }">
    <template v-if="focus">
      <div ref="placeholder" :style="placeholderStyle" />

      <div :style="{ ...floatingStyle, width: column.width + 'px' }" class="portal-container">
        <template>
          <!-- integer -->
          <fts-integer ref="inputRef" v-if="column.type == 2 || column.informationInput == 'integer'"
            v-model="innerData" controls />

          <!-- number / curreny -->
          <fts-number-currency ref="inputRef" class="fts-form-control number-currency" v-model="innerData" v-else-if="
            column.type == 3 ||
            column.type == 4 ||
            column.informationInput == 'number' ||
            column.informationInput == 'currency'
          " />



          <!-- date-time -->
          <fts-date-time ref="inputRef" :min-datetime="column.minDatetime" :max-datetime="column.maxDatetime"
            v-model="innerData" full-width v-else-if="
              column.type == 5 ||
              column.type == 6 ||
              column.informationInput == 'dateTime' ||
              column.informationInput == 'date' ||
              column.informationInput == 'time'
            " />

          <!-- select -->
          <fts-dropdown ref="inputRef" :activityId="activityId" :moduleId="moduleId" :item="column"
            :form-data="extension.extension" @input="(x) => { innerData = x }" v-else-if="(
              column.type == 7
              || column.type == 27
              || column.informationInput == 'dropDown'
              || column.informationInput == 'select'
            ) && column.type != 20" />

          <!-- locuses, tag -->
          <fts-dropdown ref="inputRef" :item="column" :form-data="extension.extension" multiple observer-height
            @input="(x) => { innerData = x }" v-else-if="
              column.type == 8 ||
              column.type == 28
            " />

          <!-- location -->
          <fts-location ref="inputRef" :item="column" :form-data="extension.extension" @input="(x) => { innerData = x }"
            @close="columnOnBlur" v-else-if="
              column.type == 9 ||
              column.informationInput == 'location'
            " />

          <!-- content -->
          <fts-content ref="inputRef" :item="column" :form-data="extension.extension" :data="innerData" float-menu-bar
            @input="(x) => { innerData = extension.extension[column.fieldName] }" v-else-if="
              column.type == 22 ||
              column.informationInput == 'content'
            " />

          <!-- file / image -->
          <fts-file-upload :item="column" :form-data="extension.extension" :vector-id="moduleId" @click.stop
            @input="(x) => { innerData = extension.extension[column.fieldName] }" v-else-if="
              column.type == 10 ||
              column.type == 11 ||
              column.type == 12 ||
              column.type == 13 ||
              column.informationInput == 'imageUpload' ||
              column.informationInput == 'imagesUpload' ||
              column.informationInput == 'fileUpload' ||
              column.informationInput == 'filesUpload'
            " />

          <!-- profile (module) -->
          <fts-user ref="inputRef" :activityId="activityId" :moduleId="moduleId" :item="column"
            :form-data="extension.extension" @input="(x) => { innerData = extension.extension[column.fieldName] }"
            v-else-if="
              column.type == 20 ||
              column.informationInput == 'dropDownUser'
            " />
          <!-- users -->
          <fts-user ref="inputRef" :activityId="activityId" :moduleId="moduleId" :item="column"
            :form-data="extension.extension" multiple observer-height
            @input="(x) => { innerData = extension.extension[column.fieldName] }" @blur="columnOnBlur"
            v-else-if="column.type == 21" />

          <!-- user -->
          <fts-user ref="inputRef" :activityId="activityId" :moduleId="moduleId" :item="column"
            :form-data="extension.extension" observer-height
            @input="(x) => { innerData = extension.extension[column.fieldName] }" @blur="columnOnBlur"
            v-else-if="column.type == 20" />

          <!-- phone num -->
          <fts-phone-number ref="inputRef" :item="column" :form-data="extension.extension"
            @input="(x) => { innerData = extension.extension[column.fieldName] }" v-else-if="
              column.type == 26 ||
              column.informationInput == 'phone'
            " />

          <!-- signature -->
          <fts-signature :vector-id="moduleId" :form-data="extension.extension" :item="column"
            @input="(x) => { innerData = extension.extension[column.fieldName] }" v-else-if="
              column.type == 29 ||
              column.informationInput == 'signature'
            " />


          <!-- default -->
          <fts-text-area ref="inputRef" v-else v-model="innerData" :rows="1"
            @enter="(e) => { if (!e.shiftKey) columnOnBlur() }" />

        </template>
      </div>
    </template>
    <template v-else>
      <!-- yes/no -->
      <div class="field-container ">
        <checkbox 
          class="inline" 
          ref="inputRef" 
          v-model="innerData" 
          :color="'#279ec6'" 
          :size="18" 
          @change="submit" 
          v-if="
            column.type == 1 ||
            column.informationInput == 'boolean' ||
            column.informationInput == 'toggle'
          "
        />
        <div class="disable-inner-click" @click.capture="focusField" v-else>
          <fts-list-view-display :form-data="extension.extension || extension" :item="column" :vector-id="moduleId"
            enable-text-alignment @click.native.prevent.stop @mousedown.native.prevent.stop />
        </div>
      </div>
    </template>
  </div>

</template>

<script>
import { classificationStore } from '../store/classificationStore';
import FTSListViewDisplay from '../elements/FTSListViewDisplay';
import FTSTextArea from '../elements/FTSTextArea';
import FTSInteger from '../elements/FTSInteger';
import FTSNumberCurrency from '../elements/FTSNumberCurrency';
import Checkbox from 'vue-material-checkbox';
import FTSDateTime from '../elements/FTSDateTime';
import FTSDropdown from '../elements/FTSDropdown';
import FTSPhoneNumber from '../elements/FTSPhoneNumber';
import FTSFileUpload from '../elements/FTSFileUpload';
import FTSUser from '../elements/FTSUser';
import FTSLocation from '../elements/FTSLocation';
import FTSContent from '../elements/FTSContent';
import FTSSignature from '../elements/FTSSignature';
import inModalOver from '../commons/overlayClick';
import changesets from 'diff-json';

export default {
  components: {
    'fts-text-area': FTSTextArea,
    'fts-integer': FTSInteger,
    'fts-number-currency': FTSNumberCurrency,
    'checkbox': Checkbox,
    'fts-date-time': FTSDateTime,
    'fts-dropdown': FTSDropdown,
    'fts-phone-number': FTSPhoneNumber,
    'fts-file-upload': FTSFileUpload,
    'fts-user': FTSUser,
    'fts-list-view-display': FTSListViewDisplay,
    'fts-location': FTSLocation,
    'fts-content': FTSContent,
    'fts-signature': FTSSignature,
  },
  props: {
    moduleId: [Number, String],
    listingId: [Number, String],
    activityId: String,
    column: Object,
    data: null,
    entryId: [Number, String],
    extension: Object,
  },
  data() {
    return {
      originalData: null,
      innerData: this.data,
      focus: false,
      loading: false,
      fileQueues: [],
      placeholderStyle: {

      },
      floatingStyle: {
        position: 'fixed',
        'min-width': '200px',
        'max-width': '300px',
      }
    }
  },
  watch: {
    data(newVal) {
      this.innerData = newVal
    }
  },
  model: {
    prop: "data",
  },
  methods: {
    preventScroll(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    },

    lockParent() {
      const container = document.querySelector('.list-view__container');
      if (container) {
        container.addEventListener('wheel', this.preventScroll, { passive: false });
        container.addEventListener('touchmove', this.preventScroll, { passive: false });

        // Optional: stop arrow keys from scrolling
        container.addEventListener('keydown', this.preventKeyScroll, { passive: false });
      }
    },

    unlockParent() {
      const container = document.querySelector('.list-view__container');
      if (container) {
        container.removeEventListener('wheel', this.preventScroll);
        container.removeEventListener('touchmove', this.preventScroll);
        container.removeEventListener('keydown', this.preventKeyScroll);
      }
    },

    preventKeyScroll(e) {
      const keys = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown'];
      if (keys.includes(e.code)) {
        e.preventDefault();
        return false;
      }
    },
    syncPosition() {
      const rect = this.$refs.container.getBoundingClientRect();

      this.floatingStyle.top = `${rect.top - 6}px`;
      this.floatingStyle.left = `${rect.left - 14}px`;

      this.floatingStyle.width = `${rect.width}px`;
      this.placeholderStyle.height = `${rect.height}px`;
      this.placeholderStyle.width = `${rect.width}px`;
    },
    focusField() {
      if (this.column.type === 14 || this.column.type === 15) return;

      this.focus = true;

      this.syncPosition();

      this.$nextTick(() => {
        if (this.column.type == 10 || this.column.type == 11 || this.column.type == 12 || this.column.type == 13 || this.column.type == 29) {
          return;
        }
        if (this.column.type === 1) {
          this.$refs.inputRef.toggle()
        } else if (this.column.type === 2 || this.column.type === 5 || this.column.type === 6 || this.column.type === 9 || this.column.type === 20 || this.column.type === 21) {
          this.$refs.inputRef.$el
            .getElementsByTagName("input")[0]
            .focus();
        } else if (this.column.type === 26) {
          this.$refs.inputRef.$el
            .getElementsByTagName("input")[1]
            .focus();
        } else if (this.column.type === 3 || this.column.type === 4) {
          this.$refs.inputRef.$el
            .focus();
        } else if (this.column.type === 22) {
          // TODO:CONTENT NOT SUPPORT PROGRAMMATICALLY FOCUS
          // this.$refs.inputRef.editor.focus();

        } else if (this.column.type === 7 || this.column.type === 27 || this.column.type === 8 || this.column.type === 28) {
          const inputEl = this.$refs.inputRef.$refs.scroll.$el.querySelector('input')
          if (inputEl) inputEl.focus()
        } else {
          this.$refs.inputRef.focus();
        }
      });
      this.lockParent();


    },
    columnOnInput: _.debounce(function () {
      this.columnValidatorTouch();
    }, 500),
    columnOnBlur() {
      this.focus = false;
      this.$nextTick(() => {
        if (this.columnValidatorTouch()) {
          this.submit();
        }
      });
      this.unlockParent();
    },
    async columnValidatorTouch() {
      console.log('validation triggered');

      return true;
    },
    async submit() {
      const diff = changesets.diff(this.originalData, this.innerData);

      if (!diff.length) return;

      this.$emit('input', this.innerData);
      this.originalData = _.cloneDeep(this.innerData);

      const extension = { [this.column.fieldName]: this.innerData };

      if (this.column.type === 7 || (this.column.type === 27 && this.column.reference)) {
        extension[`${this.column.fieldName}Id`] = this.extension.extension[`${this.column.fieldName}Id`];
      }

      window.eventBus.$emit('listing:inlineUpdated', {
        entryId: this.entryId,
        moduleId: this.moduleId,
        patch: extension,
        visibleSnapshot: _.cloneDeep(
          (this.extension && this.extension.extension) || {}
        ),
      });
    },
    handleClickOutside(e) {
      if (!this.focus) return

      const el = this.$refs.container
      // a mousedown in a lightbox or dialog the editor opened (on <body>) is not a blur:
      // closing the editor would destroy that modal with it
      if (!el.contains(e.target) && !inModalOver(e.target, el)) {
        this.columnOnBlur();
      }
    },
  },
  mounted() {
    this.syncPosition();
    window.addEventListener('scroll', this.syncPosition, true);
    document.addEventListener("mousedown", this.handleClickOutside)
    this.originalData = _.cloneDeep(this.data);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.syncPosition, true);
    document.removeEventListener("mousedown", this.handleClickOutside)
    this.unlockParent();

  },
}
</script>
<style lang="scss">
@use "./src/assets/scss/vars" as *;

.portal-container {
  z-index: $z-index-popover;
  position: absolute;
  left: 26px;
  top: 0px;
  min-width: 220px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: auto;
  background: #fff;
  border-radius: 6px;
  box-shadow: var(--fts-elevation-3);

  .fts-file-upload {
    padding: 10px;
  }
}

.field-container {
  overflow: hidden;
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  border-radius: 6px;

  >* {
    flex: 1 1 0;
    min-width: none !important;
    overflow: none !important;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .fts-editor .editor__content,
  .vs-toggle,
  .fts-form-control {
    background: #fff;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: none !important;
    border: none;

    border-color: var(--fts-gray-200) !important;

    .fts-editor .editor__content:focus-within,
    &:focus {
      border: 1px solid var(--fts-gray-200);
      box-shadow: var(--fts-elevation-3);
    }
  }

  .inline {
    margin: 0px;
    margin-left: 20px;

    .m-chckbox--ripple {
      display: none !important;
    }
  }
}

.disable-inner-click * {
  pointer-events: none;
}

.fts-list-view-display {

  &.fts-scrollbar {
    overflow: hidden !important;
  }
}
</style>
